import { render, staticRenderFns } from "./TipoAgendaAtividadeManage.vue?vue&type=template&id=0157df02&scoped=true"
import script from "./TipoAgendaAtividadeManage.vue?vue&type=script&lang=js"
export * from "./TipoAgendaAtividadeManage.vue?vue&type=script&lang=js"
import style0 from "./TipoAgendaAtividadeManage.vue?vue&type=style&index=0&id=0157df02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0157df02",
  null
  
)

export default component.exports